module.exports = __webpack_public_path__ + "img/broccoli.89219295.svg";